module.exports = __webpack_public_path__ + "static/img/star_person_service.c1199e8a.png";